export enum OperationTypeStr {
  None = 'None',
  Backup = 'Backup',
  Restore = 'Restore',
  Archive = 'Archive',
  MarkingForDelete = 'MarkingForDelete',
  DeleteItems = 'DeleteItems',
  ProcessRetention = 'ProcessRetention',
  DeleteFromStorage = 'DeleteFromStorage',
  Sync = 'Sync',
  Export = 'Export',
  ClearCustomer = 'ClearCustomer',
  DeleteUser = 'DeleteUser',
  CalculateUsersProviderSize = 'CalculateUsersProviderSize',
  Test = 'Test'
}
